import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NetworkService } from 'src/app/core/services/network.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ManualUnschedulerEventModel } from './manualunscheduler-event-model';
import { ManualUnschedulerRecursionRuleModel } from './manualunscheduler-recursion-rule-model';
import { NgbDate, NgbDateParserFormatter, NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatterService } from 'src/app/shared/services/custom-date-parser-formatter.service';
import { CustomDatepickerI18nService } from 'src/app/shared/services/custom-datepicker-i18n.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { ConfirmDialogService } from 'src/app/shared/services/confirm-dialog.service';
import { ShiftScheduleModel } from './shift-schedule-model';
import { DatePipe } from '@angular/common';
import { RecurrenceTypes } from './recursion-type-enum';
import { error } from 'console';

@Component({
  selector: 'app-manualunscheduler-event-modal',
  templateUrl: './manualunscheduler-event-modal.component.html',
  styleUrls: ['./manualunscheduler-event-modal.component.scss'],
  providers: [
      { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatterService },
      { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18nService }
    ]
})
export class ManualunschedulerEventModalComponent implements OnInit {
  @ViewChild('addEditManualunschedulerEvent', {static: false}) addEditManualunschedulerEvent: TemplateRef<Object>;
  @Input() ManualunschedulerEventId: number | undefined;
  @Input() ManualunschedulerRecursionRuleId: number | undefined;
  @Input() Plant: any;
  @Input() Line: any;
  @Output() isEventAddedOrUpdatedFlag = new EventEmitter<void>();

  selectedPlantName: any;
  selectedLineName: any;
  selectedShiftId: number = 0;
  // Use string to match option values
  selectedRecurrenceType: any = '0';
  selectedDaysOfWeekList: any[] = [];
  selectedEventStartDateTime: Date;
  selectedEventEndDateTime: Date;
  selectedEventStartDate: NgbDate | null;
  selectedEventEndDate: NgbDate | null;
  selectedEventDate: NgbDate | null;
  selectedRecursionRuleEndDate: NgbDate | null;
  miniumNgbStartDate: NgbDate; //Used for date picker min date
  miniumStartDateTime: Date; //Used to determine if an event can be deleted and if start date/time can be edited

  manualUnschedulerEvent: ManualUnschedulerEventModel;
  recursionRuleFlag: boolean = false;
  manualUnschedulerRecursionRule: ManualUnschedulerRecursionRuleModel;

  recurrenceDailyIntervalList: any[];

  recurrenceWeeklyIntervalList: any[];

  recurrenceMonthlyIntervalList: any[];
  
  recursionRuleAssociatedFlag: boolean;
  recurrenceTypeList: any[];
  recurrenceTypes = RecurrenceTypes;

  multiSelectDropDownSettings: any = {};
  hideDaysOfWeekSelectFlag: boolean = true;
  daysOfWeekList: any[];
  monthlyFirstDayOfWeekOption: number|null = null;
  showFirstWeekdayOfMonthOption: boolean = false;
  showFirstOccurrenceOfWeekdayOption:boolean = false;

  options: any;

  isEditMode: boolean = false;
  isEventStarted: boolean = false;
  isOriginalEventComplete: boolean = false;
  isAllFieldsLocked: boolean = false;
  isEventStartDateTimeEditable: boolean = false;
  isEventEndDateTimeEditable: boolean = false;
  isEventDateTimeEditable: boolean = false;
  isRecursionRuleEndDateEditable: boolean = true;
  isDeleteEnabled: boolean = false;
  isSubmitEnabled: boolean = false;
  formSubmitRequirementMessages: any[] = [];

  useShiftTimeFlag: boolean = true;
  shiftScheduleList: ShiftScheduleModel[] = [];
  filteredShiftScheduleListByDayOfWeek: ShiftScheduleModel[] = [];

  dlmStartDateTime: Date | null;
  dlmEndDateTime: Date | null;
  shiftStartDateTime: Date | null;
  shiftEndDateTime: Date | null;

  millisecondsInMinute: number = 60000;
  millisecondsInHour: number = 3600000;
  millisecondsInDay: number = 86400000;

  lineStartTime: string = '06:00:00' //Line start time is always 6am local plant time

  constructor(
    private loaderService: LoaderService, 
    private netWorkSer: NetworkService, 
    public modalService: ModalService, 
    private translate: TranslateService, 
    private toastr: ToastrService,
    private confirmDialogService: ConfirmDialogService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.manualUnschedulerEvent = new ManualUnschedulerEventModel({});
    this.manualUnschedulerRecursionRule = new ManualUnschedulerRecursionRuleModel({});

    this.options = {
      width: '85%',
      dropdownCssClass: "bigdrop",
      minimumResultsForSearch: -1
    };

    this.multiSelectDropDownSettings = {
        singleSelection: false,
        enableCheckAll: false,
        idField: 'id',
        textField: 'text'
    };
  }

  // API Calls
  // #region
  async getEvent(){
    return new Promise((resolve, reject) => {
      if (!this.ManualunschedulerEventId || this.ManualunschedulerEventId === 0) {
        resolve(this.manualUnschedulerEvent);
        return;
      }      
      
      const url = 'GetManualUnschedulerEventById/' + this.ManualunschedulerEventId;
      this.loaderService.display(true);

      if (this.ManualunschedulerEventId != 0 && this.ManualunschedulerEventId != null) {
        this.netWorkSer.httpReq('post', url).subscribe(response => {
          this.loaderService.display(false);
          if (response != null) {
            this.manualUnschedulerEvent = new ManualUnschedulerEventModel(response);
            console.log(this.manualUnschedulerEvent);
            // Handle Unscheduler events that aren't shift-based
            if (!this.manualUnschedulerEvent.ShiftScheduleId) {
              this.selectedEventStartDateTime = this.addStringTimeToDate(new Date(this.manualUnschedulerEvent.StartDate), this.manualUnschedulerEvent.EventStartTime);
              this.selectedEventEndDateTime = this.addStringTimeToDate(new Date(this.manualUnschedulerEvent.EndDate), this.manualUnschedulerEvent.EventEndTime);
              this.selectedEventStartDate = this.createNgbDateFromDate(new Date(this.manualUnschedulerEvent.StartDate));
              this.selectedEventEndDate = this.createNgbDateFromDate(new Date(this.manualUnschedulerEvent.EndDate));
              this.useShiftTimeFlag = false;
              this.determineIfDeleteIsEnabled(this.selectedEventStartDate);
              this.determineIfEventDateTimesCanBeEdited();
              this.determineIfOriginalEventIsComplete();
              this.getRecursionRule();
            }
            // Handle Unscheduler events that are shift-based
            else {
              this.selectedEventStartDateTime = new Date(this.manualUnschedulerEvent.StartDate);
              this.getShiftSchedules();
              this.getRecursionRule();
            }
            resolve(this.manualUnschedulerEvent);
          }
        },
        (error) => {
          this.loaderService.display(false);
          reject(error);
        });
      }
      this.loaderService.display(false);
    });
  }

  getRecursionRule(){
    if(this.ManualunschedulerRecursionRuleId != 0 && this.ManualunschedulerRecursionRuleId != null) {
      this.recursionRuleFlag = true;

      let url = 'GetManualUnschedulerRecursionRuleById/' + this.ManualunschedulerRecursionRuleId;
      this.loaderService.display(true);

      this.netWorkSer.httpReq('post', url).subscribe(response => {
        this.loaderService.display(false);
        if (response != null) {
          this.manualUnschedulerRecursionRule = new ManualUnschedulerRecursionRuleModel(response);
          this.selectedRecursionRuleEndDate = this.createNgbDateFromDate(new Date(this.manualUnschedulerRecursionRule.EndDate));

          this.selectedRecurrenceType = this.recurrenceTypeList.find((element) => element.value == this.manualUnschedulerRecursionRule.RecurrenceType).id;
          this.onRecurrenceTypeChange(this.selectedRecurrenceType, false);
          this.buildSelectedDayList();
          this.determineIfRecursionRuleEndDateCanBeEdited();
        }
      })
      this.loaderService.display(false);
    }
    else {
      this.recursionRuleFlag = false;
    }
  }

  getShiftSchedules() {
    if (this.manualUnschedulerEvent.LineId != 0 && this.manualUnschedulerEvent.LineId != null) {
      let url = 'GetShiftScheduleForLine/' + this.manualUnschedulerEvent.LineId;
      this.loaderService.display(true);

      this.netWorkSer.httpReq('post', url).subscribe(response => {
        this.loaderService.display(false);
        if (response != null) {
          this.shiftScheduleList = response.data.map((element: any) => new ShiftScheduleModel(element)) as ShiftScheduleModel[];

          if (this.manualUnschedulerEvent.ShiftScheduleId != null && this.manualUnschedulerEvent.ShiftScheduleId != 0) {
            this.useShiftTimeFlag = true;
            let shift = this.shiftScheduleList.find(x => x.ShiftScheduleId == this.manualUnschedulerEvent.ShiftScheduleId);
            let shiftDayOfWeek = shift?.DayOfWeek;
            let startDate = new Date(this.manualUnschedulerEvent.StartDate);
            let startDateDayOfWeek = startDate.toLocaleString('en-us',{weekday:'long'})

            // Fixes a shift-based event's day offset by calculating when the selected day-of-week is, and then advances to the next occurence of it. // When StartDate's day-of-week doesn't match the shift's DayOfWeek, advance to the next occurrence of that day
            if (shiftDayOfWeek != startDateDayOfWeek) {
              const daysOfWeekMap: {[key: string]: number} = {'Sunday': 0, 'Monday': 1, 'Tuesday': 2, 'Wednesday': 3, 'Thursday': 4, 'Friday': 5, 'Saturday': 6};
              const dayTargetNumber = daysOfWeekMap[shiftDayOfWeek!];
              const dayCurrentNumber = startDate.getDay();
              let diff = dayTargetNumber - dayCurrentNumber;
              if (diff <= 0) diff += 7;
              this.selectedEventDate = this.createNgbDateFromDate(new Date(startDate.setDate(startDate.getDate() + diff)))
            }
            else {
              this.selectedEventDate = this.createNgbDateFromDate(startDate);
            }
          }
          this.determineIfEventDateTimesCanBeEdited();
          this.getFilteredShiftSchedule();
          this.getRecursionRule();
        }
      })
      this.loaderService.display(false);
    }
  }

  addUpdateManualunschedulerEvent() {
    let url = 'AddOrUpdateManualUnschedulerEvent';
    let params = {
      "ManualUnschedulerEvent": this.manualUnschedulerEvent,
      "ManualUnschedulerRecursionRule": this.manualUnschedulerRecursionRule 
    }

    this.loaderService.display(true);
    this.netWorkSer.httpReq('post', url, "", params).subscribe(response => {
      if (response.Status != "") {
        if (response.error.includes('Fail')) {
          this.toastr.error('', response.error, environment.toastOptions);
        } 
        else {
          window.location.reload();
        }
        this.loaderService.display(false);
      }
    }, error => {
        this.loaderService.display(false);
        this.toastr.error('', "Error Occurred", environment.toastOptions);
    })
  }

  deleteEventAndAssociatedRecursionRule() {
    let url = 'DeleteManualUnschedulerEvent/' + this.manualUnschedulerEvent.Id;
    this.loaderService.display(true);
    this.netWorkSer.httpReq('delete', url).subscribe(response => {
      if (response.Status != "") {
        if (response.error.includes('Fail')) {
          this.toastr.error('', response.error, environment.toastOptions);
        } 
        else {
          window.location.reload();
        }
        this.loaderService.display(false);
      }
    }, error => {
        this.loaderService.display(false);
        this.toastr.error('', "Error Occurred", environment.toastOptions);
    })
  }

  updateRecursionRuleEndDate() {
    this.manualUnschedulerRecursionRule.EndDate = new Date().toISOString().slice(0, 10); // Set the recursion rule's end date to today in YYYY-MM-DD format

    if (this.manualUnschedulerEvent.ShiftScheduleId) { // Reformat the dates for shift-based events after getShiftSchedules() is invoked, so the C# API can properly parse them
      this.manualUnschedulerEvent.StartDate = this.datePipe.transform(this.addStringTimeToDate(new Date(this.manualUnschedulerEvent.StartDate), this.manualUnschedulerEvent.EventStartTime), 'yyyy-MM-dd HH:mm') ?? '';
      this.manualUnschedulerEvent.EndDate = this.datePipe.transform(this.addStringTimeToDate(new Date(this.manualUnschedulerEvent.EndDate), this.manualUnschedulerEvent.EventEndTime), 'yyyy-MM-dd HH:mm') ?? '';
    }

    this.addUpdateManualunschedulerEvent();
  }

  addOrRemoveRecursionExceptionDates(date:Date){
    let url = 'AddRemoveRecursionRuleExceptionDate';
    let params = {
      "RecursionRuleId": this.manualUnschedulerRecursionRule.Id,
      "Date": date
    }
    this.loaderService.display(true);
    this.netWorkSer.httpReq('post',url,"",params).subscribe(response =>{
      if(response.Status != ""){
        if(response.error.includes('Fail')){
          this.toastr.error('', response.error, environment.toastOptions);
        }
        else{
          this.getRecursionRule();
        }
        this.loaderService.display(false); 
      }     
    },
    error =>{
      this.loaderService.display(false);
      this.toastr.error('', "Error Occurred", environment.toastOptions)
    }
  );
  }
  //#endregion
  
  // Modal Open/Close
  //#region
  openModal(editExistingEventFlag: boolean) {
    // Reset selections immediately when modal opens
    this.isEditMode = editExistingEventFlag;
    this.isSubmitEnabled = false;
    this.isDeleteEnabled = false;
    this.manualUnschedulerEvent = new ManualUnschedulerEventModel({});
    this.manualUnschedulerRecursionRule = new ManualUnschedulerRecursionRuleModel({});
    this.setDropdownValues();
    this.selectedEventStartDate = null
    this.selectedEventEndDate = null;
    this.selectedRecursionRuleEndDate = null;
    this.selectedRecurrenceType = 0;
    this.selectedDaysOfWeekList = [];
    this.recursionRuleFlag = false;
    this.useShiftTimeFlag = true;
    this.isEventStartDateTimeEditable = true;
    this.isEventEndDateTimeEditable = true;
    this.isEventDateTimeEditable = true;
    this.isRecursionRuleEndDateEditable = true;
    this.isEventStarted = false;
    this.isAllFieldsLocked = false;
    this.selectedShiftId = 0;
    this.filteredShiftScheduleListByDayOfWeek = [];
    this.dlmStartDateTime = null;
    this.dlmEndDateTime = null;
    this.formSubmitRequirementMessages = [];
    this.onShiftTimeToggle();

    this.manualUnschedulerEvent.PlantId = this.Plant.id;
    this.selectedPlantName = this.Plant.plantName;
    this.manualUnschedulerEvent.LineId = this.Line.id;
    this.selectedLineName = this.Line.lineName;

    this.getMinimumStartDateForLine();
    
    if(editExistingEventFlag) {
      // Load event data
      this.getEvent();
    }
    else {
      this.getShiftSchedules();
    }

    // Open the modal
    this.modalService.open(this.addEditManualunschedulerEvent);
  }

  closeModal(modalRef?: any) {
    // Dismiss the modal
    if (modalRef) {
      modalRef.dismiss();
    }
  }
  //#endregion

  //Modal Functionality
  //#region
  onRecursionRuleToggle() {
    //Clear out recursion rule values when toggled off
    if(this.recursionRuleFlag == false) {
      this.manualUnschedulerRecursionRule = new ManualUnschedulerRecursionRuleModel({});
      this.selectedRecursionRuleEndDate = null;
      this.selectedRecurrenceType = 0;
      this.selectedDaysOfWeekList = [];
    }
    else if(this.useShiftTimeFlag){
      this.onShiftTimeToggle();
    }
  }

  onShiftTimeToggle() {
    if(!this.manualUnschedulerEvent.ShiftScheduleId){
      this.manualUnschedulerEvent.EventStartTime = '';
      this.manualUnschedulerEvent.EventEndTime = '';
    }
    if(!this.useShiftTimeFlag) {
      this.resetSelectedShift();
    }
    if(this.recursionRuleFlag){
      this.selectedRecurrenceType = this.useShiftTimeFlag ? 2 : 0;
      this.onRecurrenceTypeChange(this.selectedRecurrenceType);
      this.hideDaysOfWeekSelectFlag = !this.useShiftTimeFlag;
      this.selectedDaysOfWeekList = this.manualUnschedulerEvent.ShiftScheduleId ? [this.daysOfWeekList.find((element: { id: any; }) => element.id == (new Date(this.manualUnschedulerEvent.StartDate).getDay() + 1))] : [];
      this.manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth = false;
      this.manualUnschedulerRecursionRule.FirstWeekdayOfMonth = false;
      this.manualUnschedulerRecursionRule.FirstWeekdayMonthlyRecurrence = false;
    }
  }

  onShiftDateSelect(){
    this.resetSelectedShift();
    if(this.selectedEventDate != null){
      this.manualUnschedulerEvent.StartDate = this.createDateFromNgbDate(this.selectedEventDate).toString();
      this.manualUnschedulerEvent.EndDate = this.createDateFromNgbDate(this.selectedEventDate).toString();
      this.getShiftStartAndEndDates();
      this.handleSpecialMonthlyRecurrenceBooleans();
      this.getFilteredShiftSchedule();
    }
  }

  onDateSelect() {
    this.resetSelectedShift();
    
    if(this.selectedEventStartDate != null) {
      this.manualUnschedulerEvent.StartDate = this.createDateFromNgbDate(this.selectedEventStartDate).toString();
      this.handleSpecialMonthlyRecurrenceBooleans();
      this.getShiftStartAndEndDates();
    }

    if(this.selectedEventEndDate != null) {
      this.manualUnschedulerEvent.EndDate = this.createDateFromNgbDate(this.selectedEventEndDate).toString();
      this.determineIfOriginalEventIsComplete();
    }
  }

  resetSelectedShift(){
    this.manualUnschedulerEvent.ShiftScheduleId = null;
    this.selectedShiftId = 0;
    this.filteredShiftScheduleListByDayOfWeek = [];
  }

  getShiftStartAndEndDates() {
    if (this.selectedEventStartDate != null) {
      const date = this.createDateFromNgbDate(this.selectedEventStartDate);
      const payload = {
        currentDate: date,
        lineName: this.Line.lineName
      };
      this.netWorkSer.httpReq('post', 'GetDailyShiftTimeBounds', '', payload)
        .subscribe(response => {
          if (response) {
            this.shiftStartDateTime = new Date(response.dayStart);
            this.shiftEndDateTime = new Date(response.dayEnd);
          }
        });
    }
  }

  onRecurrenceTypeChange(id: any, resetRecurrenceIntervalFlag: boolean = true) {
    if(id ==3){
      this.handleSpecialMonthlyRecurrenceBooleans();
    }
    if(id == 2 || (id==3 && this.manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth === true)) {
      this.hideDaysOfWeekSelectFlag = false;
    }
    else {
      this.hideDaysOfWeekSelectFlag = true;
      this.selectedDaysOfWeekList = [];
    }

    //Reset selections to placeholder values
    if(id == 0) {
      this.manualUnschedulerRecursionRule.RecurrenceInterval = 0;
      this.manualUnschedulerRecursionRule.RecurrenceType = '';
    }
    else {
      if(resetRecurrenceIntervalFlag) {
        this.manualUnschedulerRecursionRule.RecurrenceInterval = 0;
      }
      this.manualUnschedulerRecursionRule.RecurrenceType = this.recurrenceTypeList.find((element) => element.id == this.selectedRecurrenceType).value;
    }
  }

  onDaySelect(event: any) {
    this.checkSubmitEnabled();
  }

  onDayDeSelect(event: any) {
    this.checkSubmitEnabled();
  }

  onShiftScheduleChange(shiftScheduleId: any) {
    let selectedShift = this.filteredShiftScheduleListByDayOfWeek.find(shift => shift.ShiftScheduleId == shiftScheduleId);

    this.selectedEventEndDate = this.createNgbDateFromDate(selectedShift?.ShiftEndDate ?? new Date(this.manualUnschedulerEvent.StartDate));

    this.manualUnschedulerEvent.ShiftScheduleId = shiftScheduleId;
    this.manualUnschedulerEvent.StartDate = selectedShift?.ShiftStartDate.toString() ?? '';
    this.manualUnschedulerEvent.EndDate = selectedShift?.ShiftEndDate.toString() ?? '';
    this.manualUnschedulerEvent.EventStartTime = selectedShift?.StartTime ?? '';
    this.manualUnschedulerEvent.EventEndTime = selectedShift?.EndTime ?? '';
    this.selectedDaysOfWeekList = [this.daysOfWeekList.find((element: { id: any; }) => element.id == (new Date(this.manualUnschedulerEvent.StartDate).getDay() + 1))]; //getDay() is 0 based so add one to match daysOfWeekList

    //Set Recurrence Type to Weekly and disable other options when a shift is selected, since all shifts are 7 day recurrences
    if(this.recursionRuleFlag) {
      this.selectedRecurrenceType = 2;
      this.onRecurrenceTypeChange(this.selectedRecurrenceType);
      
      this.selectedDaysOfWeekList = this.manualUnschedulerEvent.ShiftScheduleId ? [this.daysOfWeekList.find((element: { id: any; }) => element.id == (new Date(this.manualUnschedulerEvent.StartDate).getDay() + 1))] : [];
    }

    this.determineIfOriginalEventIsComplete();
  }

  onDelete() {
    if(this.manualUnschedulerEvent.RecursionRuleId != null && this.manualUnschedulerEvent.RecursionRuleId != 0) {
      this.confirmDialogService.setConfirmation(this.translate.instant('Admin.event_reoccurring_delete_confirmation'), 'event_reoccurring_delete_confirmation', 'admin', () => {
        this.deleteEventAndAssociatedRecursionRule()
      }, function () {
        // Cancel callback
      });
    }
    else {
      this.confirmDialogService.setConfirmation(this.translate.instant('Admin.event_delete_confirmation'), 'event_delete_confirmation', 'admin', () => {
        this.deleteEventAndAssociatedRecursionRule()
      }, function () {
        // Cancel callback
      });
    }
  }

  onRecursionExceptionSelect(date:Date){
    this.confirmDialogService.setConfirmation(this.translate.instant('Admin.recursion_exception_restore_confirmation'), 'recursion_exception_restore_confirmation', 'admin', () => {
      this.restoreRecursionException(date);
    }, function () {
      // Cancel callback
    });
  }

  onFirstWeekdayReccurrenceChange(value:number){

    if(value === 0 && this.manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth){
      this.manualUnschedulerRecursionRule.FirstWeekdayMonthlyRecurrence = true;
      this.hideDaysOfWeekSelectFlag = false;
      if(this.manualUnschedulerRecursionRule.FirstWeekdayOfMonth){
        this.manualUnschedulerRecursionRule.FirstWeekdayOfMonth = false;
      }
    }
    if(value === 1 && this.manualUnschedulerRecursionRule.FirstWeekdayOfMonth){
      this.manualUnschedulerRecursionRule.FirstWeekdayMonthlyRecurrence = true;
      this.hideDaysOfWeekSelectFlag= true;
      this.selectedDaysOfWeekList = [];
      if(this.manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth){
        this.manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth = false;
      }
    }
    if(!this.manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth && !this.manualUnschedulerRecursionRule.FirstWeekdayOfMonth){
      this.manualUnschedulerRecursionRule.FirstWeekdayMonthlyRecurrence = false;
      this.selectedDaysOfWeekList = [];
      if(this.manualUnschedulerRecursionRule.RecurrenceType != this.recurrenceTypes.Weekly){
        this.hideDaysOfWeekSelectFlag = true;
      }
    }
  }

  onShiftModeFirstOccurrenceOfWeekdayToggle(){
    this.manualUnschedulerRecursionRule.FirstWeekdayMonthlyRecurrence = this.manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth;
    if(this.manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth){
      this.selectedRecurrenceType = 3;
      this.onRecurrenceTypeChange(this.selectedRecurrenceType);
    }
  }

  onSubmit() {
    if(this.recursionRuleFlag) {
      this.buildSelectedDayString();
    }
    else {
      this.manualUnschedulerRecursionRule = new ManualUnschedulerRecursionRuleModel({});
    }
    this.addUpdateManualunschedulerEvent();
  }
  //#endregion

  //Input Validation
  //#region
  checkSubmitEnabled() {
    this.formSubmitRequirementMessages = [];
    this.isSubmitEnabled = false;

    if(this.manualUnschedulerEvent.PlantId == 0) {
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.plant_validation_error'))
    }

    if(this.manualUnschedulerEvent.LineId == 0) {
      this.formSubmitRequirementMessages.push(this.translate.instant('Defect.Line_Validation_Error'));
    }

    if(!this.checkEventDates()) {
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.event_dates_validation_error'));
    }

    if(this.manualUnschedulerEvent.EventStartTime == '' || this.manualUnschedulerEvent.EventEndTime == '') {
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.event_times_validation_error'));
    }

    if(this.recursionRuleFlag && (this.manualUnschedulerRecursionRule.RecurrenceInterval == null || this.manualUnschedulerRecursionRule.RecurrenceInterval < 1)) {
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.recursion_rule_interval_validation_error'));
    }

    if(this.recursionRuleFlag && this.manualUnschedulerRecursionRule.RecurrenceType == '') {
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.recursion_rule_type_validation_error'));
    }

    if(this.recursionRuleFlag) {
      if(this.calculateEventLengthHours() > 24 
        && (this.manualUnschedulerRecursionRule.RecurrenceType == 'DAILY' 
            || this.manualUnschedulerRecursionRule.RecurrenceType == 'WEEKLY'
            || (this.manualUnschedulerRecursionRule.RecurrenceType == 'MONTHLY' && this.manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth)
        )
      ) {
        this.formSubmitRequirementMessages.push(this.translate.instant('Admin.event_duration_recursion_type_validation_error'));
      }
    }

    if(this.recursionRuleFlag && this.manualUnschedulerRecursionRule.RecurrenceType == 'MONTHLY') {
      if(this.calculateEventLengthDays() > 26 && this.manualUnschedulerRecursionRule.FirstWeekdayOfMonth) {
        this.formSubmitRequirementMessages.push(this.translate.instant('Admin.event_duration_recursion_type_monthly_validation_error_first_weekday'));
      }
      else if(this.calculateEventLengthDays() > 28){
        this.formSubmitRequirementMessages.push(this.translate.instant('Admin.event_duration_recursion_type_monthly_validation_error'));
      }
    }

    if(this.recursionRuleFlag && !this.checkRecursionDate()) {
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.recursion_rule_date_validation_error'));
    }

    if(this.recursionRuleFlag && !this.hideDaysOfWeekSelectFlag && this.selectedDaysOfWeekList.length == 0) {
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.recursion_rule_days_validation_error'));
    }
    if(!this.recursionRuleFlag && this.ManualunschedulerEventId != undefined && new Date(this.manualUnschedulerEvent.EndDate) < new Date()) {
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.edit_ended_event_validation_error'));
    }

    if(this.recursionRuleFlag && this.ManualunschedulerRecursionRuleId != undefined && new Date(this.manualUnschedulerRecursionRule.EndDate) < new Date()) {
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.edit_ended_event_validation_error'));
    }
    if(this.useShiftTimeFlag && this.recursionRuleFlag && this.manualUnschedulerRecursionRule.RecurrenceType == 'MONTHLY' && (!this.showFirstOccurrenceOfWeekdayOption || !this.manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth)){
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.month_not_valid_reccurrence_for_shift_error'))
    }
    if((this.isEventStartDateTimeEditable || this.isEventStartDateTimeEditable) && this.miniumStartDateTime.getTime() >= this.addStringTimeToDate(new Date(this.manualUnschedulerEvent.StartDate),this.manualUnschedulerEvent.EventStartTime).getTime()){
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.start_time_would_occur_before_next_run_error'))
    }

    if(this.isEventEndDateTimeEditable && this.miniumStartDateTime.getTime() >= this.addStringTimeToDate(new Date(this.manualUnschedulerEvent.EndDate),this.manualUnschedulerEvent.EventEndTime).getTime()){
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.end_time_would_occur_before_next_run_error'))
    }
    
    if(this.addStringTimeToDate(new Date(this.manualUnschedulerEvent.StartDate),this.manualUnschedulerEvent.EventStartTime).getTime() 
      == this.addStringTimeToDate(new Date(this.manualUnschedulerEvent.EndDate),this.manualUnschedulerEvent.EventEndTime).getTime() ){
      this.formSubmitRequirementMessages.push(this.translate.instant('Admin.zero_time_error_validation_message'))
    }

    if(this.formSubmitRequirementMessages.length == 0) {      
      this.isSubmitEnabled = true;
    }
  }
  
  checkEventDates(): boolean {
    if((!this.useShiftTimeFlag && this.selectedEventStartDate != null && this.selectedEventEndDate != null) || (this.useShiftTimeFlag && this.selectedEventDate != null)) {
      let startDate: Date = new Date(this.manualUnschedulerEvent.StartDate);
      let startDateTime: Date = this.addStringTimeToDate(startDate, this.manualUnschedulerEvent.EventStartTime);
      this.manualUnschedulerEvent.StartDate = this.datePipe.transform(startDateTime, 'yyyy-MM-dd HH:mm') ?? '';

      let endDate : Date = new Date(this.manualUnschedulerEvent.EndDate);
      let endDateTime: Date = this.addStringTimeToDate(endDate, this.manualUnschedulerEvent.EventEndTime);
      this.manualUnschedulerEvent.EndDate = this.datePipe.transform(endDateTime, 'yyyy-MM-dd HH:mm') ?? '';

      if(startDateTime <= endDateTime) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  checkRecursionDate(): boolean {
    const eventDateNgb = this.useShiftTimeFlag ? this.selectedEventDate : this.selectedEventStartDate;
    if (eventDateNgb != null && this.selectedRecursionRuleEndDate != null) {

      const dateRecursionEnd: Date = this.createDateFromNgbDate(this.selectedRecursionRuleEndDate);
      this.manualUnschedulerRecursionRule.EndDate = this.datePipe.transform(dateRecursionEnd, 'yyyy-MM-dd') ?? '';
      const dateOfEvent: Date = this.createDateFromNgbDate(eventDateNgb);

      if (dateOfEvent.getTime() <= dateRecursionEnd.getTime()) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  restoreRecursionException(date:Date){
    this.loaderService.display(true);
    this.addOrRemoveRecursionExceptionDates(date);
  }

  getMinimumStartDateForLine() {
    let startDateWithLineStartTime = this.addStringTimeToDate(new Date(), this.lineStartTime);

    if(new Date() > startDateWithLineStartTime) {
      startDateWithLineStartTime.setDate(startDateWithLineStartTime.getDate() + 1)
      this.miniumNgbStartDate = this.createNgbDateFromDate(startDateWithLineStartTime);
      this.miniumStartDateTime = new Date(startDateWithLineStartTime);
    }
    else {
      this.miniumNgbStartDate = this.createNgbDateFromDate(startDateWithLineStartTime);
      this.miniumStartDateTime = new Date(startDateWithLineStartTime);
    }
  }
  //#endregion

  //Utility Functions
  //#region
  convertStringToNumber(input: string | null): number {
    if(input == null || input == '') {
      return 0
    }
    else {
      return +input;
    }
  }

  createDateFromNgbDate(ngbDate: NgbDate): Date {
    return new Date(
                      ngbDate.year, 
                      ngbDate.month - 1, // Subtract 1 because NgbDate months are 1-based
                      ngbDate.day
                    );
  }

  createNgbDateFromDate(date: Date): NgbDate {
    return new NgbDate(
                        date.getFullYear(),
                        date.getMonth() + 1, // Add 1 because NgbDate months are 1-based
                        date.getDate()
                      );
  }

  calculateEventLengthHours() {
    let eventStartDateTime = this.addStringTimeToDate(new Date(this.manualUnschedulerEvent.StartDate), this.manualUnschedulerEvent.EventStartTime);

    let eventEndDateTime = this.addStringTimeToDate(new Date(this.manualUnschedulerEvent.EndDate), this.manualUnschedulerEvent.EventEndTime);

    // Calculate the difference in milliseconds between the two dates
    let differenceInMs: number = Math.abs(eventEndDateTime.getTime() - eventStartDateTime.getTime());

    // Calculate the difference in days by dividing the difference in milliseconds by milliseconds in an hour
    return Math.ceil(differenceInMs / this.millisecondsInHour);
  }

  calculateEventLengthDays() {
    let eventStartDateTime = this.addStringTimeToDate(new Date(this.manualUnschedulerEvent.StartDate), this.manualUnschedulerEvent.EventStartTime);

    let eventEndDateTime = this.addStringTimeToDate(new Date(this.manualUnschedulerEvent.EndDate), this.manualUnschedulerEvent.EventEndTime);

    // Calculate the difference in milliseconds between the two dates
    let differenceInMs: number = Math.abs(eventEndDateTime.getTime() - eventStartDateTime.getTime());

    // Calculate the difference in days by dividing the difference in milliseconds by milliseconds in a day
    return Math.ceil(differenceInMs / this.millisecondsInDay);
  }

  getFilteredShiftSchedule() {
    let selectedDayOfWeek = this.createDateFromNgbDate(this.selectedEventDate!).toLocaleString('en-us',{weekday:'long'});
    this.filteredShiftScheduleListByDayOfWeek = this.shiftScheduleList.filter(x=> x.DayOfWeek == selectedDayOfWeek);
    this.filteredShiftScheduleListByDayOfWeek.sort(this.compareShifts);
    this.filteredShiftScheduleListByDayOfWeek.forEach(x =>{
      let date =  this.resetDateToMidnight(this.createDateFromNgbDate(this.selectedEventDate!));
      let startDateTime = this.addStringTimeToDate(new Date(date), x.StartTime);
      let endDateTime = this.addStringTimeToDate(new Date(date), x.EndTime);
      let startDateCurrentDay = this.isShiftStartTimeBeforeEndTime(startDateTime,endDateTime);

      if(startDateCurrentDay){
        x.ShiftStartDate = new Date(date);
        x.ShiftEndDate = new Date(date);
      }
      else if(this.doesElementMatchArrayIndex(this.filteredShiftScheduleListByDayOfWeek,x,this.filteredShiftScheduleListByDayOfWeek.length - 1) || startDateTime == endDateTime){
        x.ShiftStartDate = new Date(date);
        x.ShiftEndDate = new Date(new Date(date).setDate(new Date(date).getDate()+1));
      }
      else if(this.doesElementMatchArrayIndex(this.filteredShiftScheduleListByDayOfWeek,x,0)){
        x.ShiftStartDate = new Date(new Date(date).setDate(new Date(date).getDate()-1));
        x.ShiftEndDate = new Date(date);
      }
    })

    this.filteredShiftScheduleListByDayOfWeek.sort((a, b) => a.ShiftEndDate.getTime() - b.ShiftEndDate.getTime());
    if(this.manualUnschedulerEvent.ShiftScheduleId != null && this.manualUnschedulerEvent.ShiftScheduleId > 0) {
      this.selectedShiftId = this.manualUnschedulerEvent.ShiftScheduleId;
      this.onShiftScheduleChange(this.selectedShiftId);
    }
  }

  compareShifts(a:ShiftScheduleModel,b:ShiftScheduleModel){
    if(a.ShiftDescriptionTDV < b.ShiftDescriptionTDV){
      return -1;
    }
    if(a.ShiftDescriptionTDV > b.ShiftDescriptionTDV){
      return 1;
    }
    return 0;
  }

  isShiftStartTimeBeforeEndTime(start:Date,end:Date){
    return start < end;
  }

  doesElementMatchArrayIndex(array:Array<ShiftScheduleModel>,element:ShiftScheduleModel,index: number){
    return array.findIndex(x =>x.ShiftDescriptionTDV == element.ShiftDescriptionTDV) == index;
  }

  // Used for getting days of week on edit of an existing event with recursion rule
  buildSelectedDayList() {
    if(!this.hideDaysOfWeekSelectFlag) {
      let daysArray = this.manualUnschedulerRecursionRule.DaysOfWeek?.split(',') ?? [];
      let daysList = [];
      for(let day of daysArray) {
        daysList.push(this.daysOfWeekList.find((element: { value: any; }) => element.value === day))
      }

      this.selectedDaysOfWeekList = daysList;
    }
  };

  buildSelectedDayString() {
    this.manualUnschedulerRecursionRule.DaysOfWeek = null;
    if(!this.hideDaysOfWeekSelectFlag) {
      for(let element of this.selectedDaysOfWeekList) {
        if(this.manualUnschedulerRecursionRule.DaysOfWeek == '' || this.manualUnschedulerRecursionRule.DaysOfWeek == null) {
          this.manualUnschedulerRecursionRule.DaysOfWeek = this.daysOfWeekList.find((day: { id: number; }) => element.id === day.id).value;
        }
        else {
          this.manualUnschedulerRecursionRule.DaysOfWeek = this.manualUnschedulerRecursionRule.DaysOfWeek + ',' + this.daysOfWeekList.find((day: { id: number; }) => element.id === day.id).value;
        }
      }
    }
  }

  setDropdownValues() {
    // Value used for setting value of ManualUnschedulerRecursionRuleModel.RecurrenceType
    this.recurrenceTypeList = [
      { id:1, text:this.translate.instant('CIL.Daily'), value: this.recurrenceTypes.Daily},
      { id:2, text:this.translate.instant('CIL.Weekly'), value: this.recurrenceTypes.Weekly},
      { id:3, text:this.translate.instant('CIL.Monthly'), value: this.recurrenceTypes.Monthly}
    ];

    this.recurrenceDailyIntervalList = [
      { id:1, text:this.translate.instant('Admin.RecurrenceDailyIntervals.every_day')},
      { id:2, text:this.translate.instant('Admin.RecurrenceDailyIntervals.every_other_day')}, 
      { id:3, text:this.translate.instant('Admin.RecurrenceDailyIntervals.every_third_day')}, 
      { id:4, text:this.translate.instant('Admin.RecurrenceDailyIntervals.every_fourth_day')}, 
      { id:5, text:this.translate.instant('Admin.RecurrenceDailyIntervals.every_fifth_day')}, 
      { id:6, text:this.translate.instant('Admin.RecurrenceDailyIntervals.every_sixth_day')}
    ];

    this.recurrenceWeeklyIntervalList = [
      { id:1, text:this.translate.instant('Admin.RecurrenceWeeklyIntervals.every_week')},
      { id:2, text:this.translate.instant('Admin.RecurrenceWeeklyIntervals.every_other_week')}, 
      { id:3, text:this.translate.instant('Admin.RecurrenceWeeklyIntervals.every_third_week')}
    ];

    this.recurrenceMonthlyIntervalList = [
      { id:1, text:this.translate.instant('Admin.RecurrenceMonthlyIntervals.every_month')},
      { id:2, text:this.translate.instant('Admin.RecurrenceMonthlyIntervals.every_other_month')}, 
      { id:3, text:this.translate.instant('Admin.RecurrenceMonthlyIntervals.every_third_month')}, 
      { id:4, text:this.translate.instant('Admin.RecurrenceMonthlyIntervals.every_fourth_month')}, 
      { id:5, text:this.translate.instant('Admin.RecurrenceMonthlyIntervals.every_fifth_month')}, 
      { id:6, text:this.translate.instant('Admin.RecurrenceMonthlyIntervals.every_sixth_month')}, 
      { id:7, text:this.translate.instant('Admin.RecurrenceMonthlyIntervals.every_seventh_month')},
      { id:8, text:this.translate.instant('Admin.RecurrenceMonthlyIntervals.every_eighth_month')},
      { id:9, text:this.translate.instant('Admin.RecurrenceMonthlyIntervals.every_ninth_month')}, 
      { id:10, text:this.translate.instant('Admin.RecurrenceMonthlyIntervals.every_tenth_month')}, 
      { id:11, text:this.translate.instant('Admin.RecurrenceMonthlyIntervals.every_eleventh_month')}
    ];

    // Value used for setting value of ManualUnschedulerRecursionRuleModel.DaysOfWeek
    this.daysOfWeekList = [
      { id:1, text:this.translate.instant('Admin.DaysOfWeekAbbreviation.sunday_abbreviation'), value:'SU'},
      { id:2, text:this.translate.instant('Admin.DaysOfWeekAbbreviation.moday_abbreviation'), value:'MO'}, 
      { id:3, text:this.translate.instant('Admin.DaysOfWeekAbbreviation.tuesday_abbreviation'), value:'TU'}, 
      { id:4, text:this.translate.instant('Admin.DaysOfWeekAbbreviation.wednesday_abbreviation'), value:'WE'}, 
      { id:5, text:this.translate.instant('Admin.DaysOfWeekAbbreviation.thursday_abbreviation'), value:'TH'}, 
      { id:6, text:this.translate.instant('Admin.DaysOfWeekAbbreviation.friday_abbreviation'), value:'FR'}, 
      { id:7, text:this.translate.instant('Admin.DaysOfWeekAbbreviation.saturday_abbreviation'), value:'SA'}
    ];
  }

  determineIfDeleteIsEnabled(startDate: NgbDate | null) {
    if(startDate != null) {
      if(startDate.after(this.miniumNgbStartDate)) {
        this.isDeleteEnabled = true;
      }
      else if(startDate.equals(this.miniumNgbStartDate)) {
        if(this.miniumStartDateTime < this.selectedEventStartDateTime) {
          this.isDeleteEnabled = true;
        }
      }
    }
  }

  determineIfEventDateTimesCanBeEdited() {
    if(!this.useShiftTimeFlag){
      if(this.resetDateToMidnight(new Date()) >= this.resetDateToMidnight(this.selectedEventStartDateTime)) {
        this.isEventStartDateTimeEditable = false;
      }
      else{
        this.isEventStartDateTimeEditable = true;
      }
  
      if(this.resetDateToMidnight(new Date()) >= this.resetDateToMidnight(this.selectedEventEndDateTime)) {
        this.isEventEndDateTimeEditable = false;
      }
      else{
        this.isEventEndDateTimeEditable = true;
      }

      if(this.isEditMode) {
        this.isEventStarted = !this.isEventStartDateTimeEditable;
      }
    }
    else{
      if((this.selectedEventDate == null || this.selectedEventDate == undefined) 
        || 
         (this.selectedEventDate != null && this.selectedEventDate != undefined && this.resetDateToMidnight(new Date()) >= this.addStringTimeToDate(this.createDateFromNgbDate(this.selectedEventDate),'00:00:00'))){
            this.isEventDateTimeEditable = true;
      }
      else{
        this.isEventDateTimeEditable = false;
      }

      if(this.isEditMode && this.selectedEventDate != null && this.selectedEventDate != undefined) {
        this.isEventStarted = this.resetDateToMidnight(new Date()) >= this.addStringTimeToDate(this.createDateFromNgbDate(this.selectedEventDate),'00:00:00');
      }
    }

  }

  determineIfOriginalEventIsComplete() {
     this.isOriginalEventComplete = new Date() > new Date(this.manualUnschedulerEvent.EndDate);
  }

  determineIfRecursionRuleEndDateCanBeEdited() {
    if(new Date() > new Date(this.manualUnschedulerRecursionRule.EndDate)) {
      this.isRecursionRuleEndDateEditable = false;
      this.isAllFieldsLocked = true;
    }
  }

  determineIfDateIsFirstWeekdayOfMonth(dateStr:string){
    let inputDate: Date = new Date(dateStr);
    const year: number = inputDate.getFullYear();
    const month: number = inputDate.getMonth();
    
    const firstOfMonth : Date = new Date(year,month,1);

    let weekday = firstOfMonth.getDay();
    
    if(weekday === 0){
      firstOfMonth.setDate(firstOfMonth.getDate()+1);
    }
    else if(weekday ===6){
      firstOfMonth.setDate(firstOfMonth.getDate()+1);
    }


    return inputDate.getTime() === firstOfMonth.getTime();
  }

  handleSpecialMonthlyRecurrenceBooleans(){
      this.showFirstWeekdayOfMonthOption = this.determineIfDateIsFirstWeekdayOfMonth(this.manualUnschedulerEvent.StartDate);
      this.showFirstOccurrenceOfWeekdayOption = new Date(this.manualUnschedulerEvent.StartDate).getDate() <= 7;
      if(!this.showFirstWeekdayOfMonthOption){
        this.manualUnschedulerRecursionRule.FirstWeekdayOfMonth = false;
        this.onFirstWeekdayReccurrenceChange(1);
      }
      if(!this.showFirstOccurrenceOfWeekdayOption){
        this.manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth = false;
        this.onFirstWeekdayReccurrenceChange(0);
      }
  }

  resetDateToMidnight(date:Date){
    let newDate = new Date(date);
    newDate.setHours(0);
    newDate.setMinutes(0);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);
    return newDate;
  }

  addStringTimeToDate(date: Date, time: string): Date {
    let newDate = new Date(date);
    try{
    let timeParts = time.split(':').map(Number);
    newDate.setHours(timeParts[0]);
    newDate.setMinutes(timeParts[1]);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);
    }
    catch(error){
      console.error(error);
    }
    finally{
      return newDate;
    }

  }
  //#endregion
}
